import angular from 'angular';

angular.module('app.ctrls')
    .controller('ConfirmModalController', ['$scope', '$modalInstance', 'message', function($scope, $modalInstance, message){

            $scope.message = message;

            $scope.ok = function () {
                // Pass scope.message, so that resolve will have access to the selected values
                $modalInstance.close($scope.message);
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };

        }]);